import { required, optional, array, obj } from 'AppReact/schema';


const schedule = {
  dates: array('integer'),
  day: array('integer'),
  hour: array('integer'),
  minute: array('integer'),
  month: array('integer'),
  wday: array('integer'),
  week: array('integer'),
  year: array('integer'),
}


export default {
  id: required('integer'),
  type: required('string'),
  template: required('string'),
  property: required('string'),
  created_by: required('string'),
  cancelled_by: optional('string'),
  unit_id: optional('integer'),
  assigned_to: optional('string'),
  creation_date: required('jsDate'),
  completion_date: optional('jsDate'),
  cancellation_date: optional('jsDate'),
  cancellation_reason: optional('string'),
  tenant: optional('string'),
  num_items: optional('integer'),
  completed_items: optional('integer'),
  started_items: optional('integer'),
  unit: optional('string'),

  last_run: optional('jsDate'),
  next_run: optional('jsDate'),

  template_id: optional('integer'),
  property_id: required('integer'),
  admin_id: optional('integer'),
  tech_id: optional('integer'),
  tenant_id: optional('integer'),

  schedule: optional('string')
}
